// Blog.jsx
import React from "react";
import "./Blog.scss";
import HeroImg from "../Components/Layouts/HeroImg";
import YouTube from "../Components/Videos/Video";

const Blog = () => {
  return (
    <>
    <HeroImg heading="Our Blog" text= "Home / Blog"/>
    <div className="marquee-container">
        <p className="marquee-text">Currently, we don’t have any published blogs. Stay tuned for updates!☹️</p>
        </div>
    <div className="blog-container">
      <div className="blog-content">
        <YouTube url="https://www.youtube.com/watch?v=fqda6vwOZWA&list=PLUiMfS6qzIMxxrSu2_XMSoHifyms-FG15" />
        <a target="_blank" rel="noreferrer" href="https://youtube.com/playlist?list=PLUiMfS6qzIMxxrSu2_XMSoHifyms-FG15&si=A5_vkn1mbhxF5zth">Watch More...</a>.
      </div>
    </div>
    </>
  );
};

export default Blog;